// #region Imports

import type { ThemeGeneratorFactoryFn } from '../interfaces/IThemeGeneratorFactory';
import { LchThemeGeneratorStrategy } from './abstracts/LchThemeGeneratorStrategy';

// #endregion

/**
 * Joy theme generator strategy.
 *
 * @remarks
 * Extends {@link LchThemeGeneratorStrategy} without customization.
 *
 * @public
 */
export class JoyThemeGeneratorStrategy extends LchThemeGeneratorStrategy {

}

/**
 * Generates a Joy theme generator strategy.
 *
 * @public
 */
export function createJoyTheme(): ThemeGeneratorFactoryFn {
    const strategy = new JoyThemeGeneratorStrategy();

    return () => strategy;
}
